import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import getGroupAsAttendee from 'owa-calendar-forms-common/lib/utils/getGroupAsAttendee';
import type { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { InfoBarViewStates } from 'owa-calendar-info-bar/lib/utils/allViewStates';
import { hasGroupAsAttendee, isOnGroupCalendar } from 'owa-calendar-event-capabilities';
import { logUsage } from 'owa-analytics';
import { updateRequiredAttendees } from 'owa-calendar-compose-form-actions';

/**
 * These are related to events on group calendar
 * @param event : The subject event
 */
export default (originalEvent: CalendarEvent, event: CalendarEvent): InfoBarMessageViewState[] => {
    if (!isOnGroupCalendar(event)) {
        return [];
    }

    const isGroupAnAttendee = hasGroupAsAttendee(event);
    const isGroupAnOriginalAttendee = hasGroupAsAttendee(originalEvent);

    // The following const determines whether to show the "Invite group" infobar or the "Group will receive updates/cancellation" infobar.
    // We will show the following:
    // 1. The "Invite group" infobar if the group is not an attendee in the current event & wasn't an
    //    attendee in original event either.
    // 2. If the group was attendee in original event, but removed from attendees now, then we will show the
    //    "Group members will get a cancellation" message
    // 3. If the group was an attendee in the original event and is still an attendee, then we will show the
    //    "Group members will get invites in their Inbox" message.
    const groupWillReceiveInviteOrCancellationInfoBar =
        isGroupAnAttendee || isGroupAnOriginalAttendee;

    if (groupWillReceiveInviteOrCancellationInfoBar) {
        return [
            InfoBarViewStates.getEventWillBeSentToAllGroupMembers({
                isGroupAnAttendee: isGroupAnAttendee,
                isGroupOriginalAttendee: isGroupAnOriginalAttendee,
            }),
        ];
    } else {
        return [
            InfoBarViewStates.getSendEventToAllGroupMembers({
                onSendEventToAllGroupMembersClicked: () => {
                    logUsage('inviteGroupMembersClicked', ['FullCompose']);
                    let requiredAttendees = [...event.RequiredAttendees, getGroupAsAttendee(event)];
                    updateRequiredAttendees(requiredAttendees);
                },
            }),
        ];
    }
};
